import { DataBean } from "../DataBean";


export class ValueTypeConstants extends DataBean {
    public async getElectronicPayrollValueTypeConstants(args: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_getElectronicPayrollValueTypeConstants_Number", [args]);
    }


}